import React, { useState } from "react";
import { oralModelToDetails } from "../../models/Oral.model";
import { OralModel } from "../../models/Oral.model";
import styled from "styled-components";
import { OralItem } from "./oral-item";
import { OralDetailDrawer } from "./OralDetailDrawer";

type Props = {
    products: OralModel[]
    onRemoveItem?: (id: number) => void
    onItemChange: (id: number, volume: string, unity: string) => void
}

const ListContainer = styled.div`
  display: grid;
  grid-auto-rows: minmax(100px, auto);
  width: 100%;
  gap: 16px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr))
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr))
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr))
  }
`

export const OralList: React.FC<Props> = (
    { products, onRemoveItem, onItemChange }
) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [itemSelected, setItemSelected] = useState<OralModel|null>(null)

    return (
        <ListContainer>
            {
                itemSelected && <OralDetailDrawer
                    open={modalOpen}
                    detail={oralModelToDetails(itemSelected)}
                    onClose={() => setModalOpen(false)}
                />
            }

            {
                products && products.map((product) =>
                    <OralItem
                        id={product.id || 0}
                        key={product.id}
                        name={product.name}
                        description={product.description}
                        unity={product.unity}
                        min={product.min}
                        max={product.max}
                        volume={product.volume}
                        onRemoveItem={onRemoveItem}
                        onItemClick={(id: number) => {
                            setItemSelected(products.find(p => p.id === id) || null)
                            setModalOpen(true)
                        }}
                        onItemChange={onItemChange}
                    />
                )
            }
        </ListContainer>
    )
}